import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import MessagesEditForm from './../../elements/notifications/messages';
import Loading from "../../elements/loading";

class NotificationMessages extends Component {
	render(){
		let { notification_messages } = this.props;
		return(
			(notification_messages.isFetching ? <Loading/>:
				<MessagesEditForm
					messages={this.props.notification_messages}
					modality={this.props.match.params.modality}
					project={this.props.project}
				/>)
		);
	}

	componentWillMount() {
		let { modality } = this.props.match.params;
		this.props.fetchNotificationMessages(modality);
	}

	componentWillReceiveProps(newprops) {
		let { modality } = newprops.match.params;

		if(newprops.match.params !== this.props.match.params) {
			this.props.fetchNotificationMessages(modality);
		}
	}
}

export default BaseLayout(NotificationMessages, {
	title: `Mensajes de notificación`,
	subnav: {
		icon: 'fa-envelope',
		name: 'Notificaciones',
		actions: [
			{
				type: null,
				url: null,
				name: '',
				element: null
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/notifications/messages.jsx